/**
 * Cliente del boton de traducir del lector.
 *
 * El texto de un manga esta pintado dentro de la imagen, asi que no se puede
 * seleccionar ni copiar: hay que leerlo con OCR. Eso lo hace el VPS, que ya
 * tiene la pagina al lado (la sirve el propio Suwayomi) y donde Tesseract
 * tarda milisegundos. **No pasa por Claude y no cuesta dinero.**
 *
 * Se manda la RUTA de la pagina y el punto tocado, no la imagen: subir un
 * JPEG de 300 KB desde el iPhone por datos moviles seria, con diferencia, lo
 * mas lento de la operacion.
 *
 * Cuelga de `/recap` como Zangetsu y por el mismo motivo: es el prefijo que
 * Caddy protege con la autenticacion basica que la app ya manda.
 */

import { cabecerasAuth, ErrorApi } from './cliente'

export interface Traduccion {
  /** Lo que se leyo en la pagina, para poder comparar si suena raro. */
  original: string
  traduccion: string
  /** Cual de los traductores respondio: google, mymemory o argos. */
  motor?: string
  /** Cuando no habia texto donde se toco. */
  nota?: string
}

export async function traducirPunto(
  ruta: string,
  x: number,
  y: number,
): Promise<Traduccion> {
  let respuesta: Response
  try {
    respuesta = await fetch('/recap/traducir', {
      method: 'POST',
      headers: { ...cabecerasAuth(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ ruta, x, y }),
    })
  } catch {
    throw new ErrorApi('No se pudo conectar con el servidor')
  }
  if (respuesta.status === 401) {
    throw new ErrorApi('Usuario o contrasena incorrectos', 401, true)
  }
  if (!respuesta.ok) {
    // El servicio explica que le paso ("Falta tesseract en el servidor", "No
    // se pudo traducir…"), y eso vale mucho mas que un numero de estado.
    const datos = (await respuesta.json().catch(() => null)) as { error?: string } | null
    throw new ErrorApi(
      datos?.error ?? `El servidor respondio ${respuesta.status}`,
      respuesta.status,
    )
  }
  return (await respuesta.json()) as Traduccion
}
